export default {
  subtitle: 'Avaimet todentavat Partner API:lle lähetetyt pyynnöt. Lähetä ne x-api-key-otsikossa.',
  never_used: 'Ei koskaan käytetty',
  revoke_confirm: 'Peruutetaanko tämä avain? Sitä käyttävät pyynnöt lakkaavat toimimasta välittömästi.',
  columns: {
    name: 'Nimi',
    key: 'Avain',
    status: 'Tila',
    last_used_at: 'Viimeksi käytetty',
    created_at: 'Luotu',
  },
  statuses: {
    active: 'Aktiivinen',
    revoked: 'Peruutettu',
  },
  buttons: {
    create: 'Luo avain',
    revoke: 'Peruuta',
  },
  toasts: {
    load_error: 'API-avaimia ei voitu ladata.',
    error: 'Jokin meni pieleen. Yritä uudelleen.',
    revoked: 'API-avain peruutettu.',
  },
};
